export enum PlanExpirationLevel {
  INFO = 'info',
  WARNING = 'warning',
  ERROR = 'error',
}
